
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/cookiePolicy",
      function () {
        return require("private-next-pages/cookiePolicy.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/cookiePolicy"])
      });
    }
  